var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1_ico/sleepface") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.0029,1.4186 C5.5459,1.7486 5.0439,1.9226 4.4999,1.9226 L4.4999,1.9226 C3.9579,1.9226 3.4549,1.7486 2.9949,1.4186 L2.9949,1.4186 C2.5389,1.0916 2.1379,0.6036 1.8569,0.0006 L1.8569,0.0006 L-0.0001,0.8826 C0.4179,1.7836 1.0329,2.5556 1.8049,3.1116 L1.8049,3.1116 C2.5729,3.6656 3.5069,3.9996 4.4999,3.9996 L4.4999,3.9996 C5.4949,3.9996 6.4279,3.6656 7.1959,3.1116 L7.1959,3.1116 C7.9659,2.5556 8.5819,1.7836 8.9999,0.8856 L8.9999,0.8856 L7.1439,0.0006 C6.8629,0.6036 6.4599,1.0916 6.0029,1.4186 L6.0029,1.4186 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0029,1.4186 C20.5459,1.7486 20.0429,1.9226 19.5009,1.9226 L19.5009,1.9226 C18.9579,1.9226 18.4539,1.7486 17.9959,1.4186 L17.9959,1.4186 C17.5379,1.0916 17.1369,0.6036 16.8569,0.0006 L16.8569,0.0006 L14.9999,0.8826 C15.4199,1.7836 16.0349,2.5556 16.8049,3.1116 L16.8049,3.1116 C17.5739,3.6656 18.5079,3.9996 19.5009,3.9996 L19.5009,3.9996 C20.4949,3.9996 21.4259,3.6656 22.1939,3.1116 L22.1939,3.1116 C22.9649,2.5556 23.5809,1.7836 23.9999,0.8856 L23.9999,0.8856 L22.1439,0.0006 C21.8629,0.6036 21.4609,1.0916 21.0029,1.4186 L21.0029,1.4186 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.9999,10.1166 C7.2689,12.4286 9.7049,13.9996 12.4989,13.9996 L12.4989,13.9996 C15.2959,13.9996 17.7319,12.4286 18.9999,10.1156 L18.9999,10.1156 L17.0399,9.0006 C16.1469,10.6206 14.4519,11.7136 12.4989,11.7136 L12.4989,11.7136 C10.5469,11.7136 8.8539,10.6206 7.9609,9.0006 L7.9609,9.0006 L5.9999,10.1166 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-7",
    points: "-8 -16 31.9999 -16 31.9999 23.9996 -8 23.9996"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "v0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B1_\\u30C8\\u30C3\\u30D7\\uFF08\\u5C65\\u6B74\\u306A\\u3057\\uFF09",
    transform: "translate(-168.000000, -314.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1_ico/sleepface",
    transform: "translate(168.000000, 314.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1_ico",
    transform: "translate(8.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#A69762",
    mask: "url(#mask-2)",
    points: "-5.0001 8.9996 13.9999 8.9996 13.9999 -5.0004 -5.0001 -5.0004"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#A69762",
    mask: "url(#mask-4)",
    points: "9.9999 8.9996 28.9999 8.9996 28.9999 -5.0004 9.9999 -5.0004"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-8"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    fill: "#A69762",
    mask: "url(#mask-6)",
    points: "0.9999 18.9996 23.9999 18.9996 23.9999 3.9996 0.9999 3.9996"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,20.177 C3.065,20.177 -4.177,12.934 -4.177,4 C-4.177,-4.935 3.065,-12.178 12,-12.178 C20.935,-12.178 28.177,-4.935 28.177,4 C28.177,12.934 20.935,20.177 12,20.177 M12,-16 C0.954,-16 -8,-7.046 -8,4 C-8,15.045 0.954,24 12,24 C23.046,24 32,15.045 32,4 C32,-7.046 23.046,-16 12,-16",
    id: "Fill-10",
    fill: "#A69762",
    mask: "url(#mask-8)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.d721eb44387f3dfaee5e09d732c0e890.svg";
export { ForwardRef as ReactComponent };